var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimezoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01699 6.72417C7.72105 4.88903 8.92884 3.4225 9.99989 2.52086C11.0709 3.42249 12.2787 4.88903 12.9828 6.72417H7.01699ZM5.95315 6.72417C6.65612 4.67186 7.93848 3.02174 9.12007 1.96097C6.18796 2.26537 3.72151 4.13729 2.57328 6.72417H5.95315ZM2.20672 7.72417H5.66652C5.63173 7.8745 5.60021 8.0266 5.5722 8.18042C5.34017 9.45466 5.35148 10.8322 5.71878 12.2757H2.20668C1.99529 11.5539 1.8819 10.7902 1.8819 10C1.8819 9.20978 1.9953 8.44604 2.20672 7.72417ZM6.69611 7.72417H13.3037C13.3576 7.93229 13.4046 8.14417 13.4438 8.35959C13.661 9.5526 13.6444 10.8705 13.2454 12.2757L6.75443 12.2757C6.35538 10.8705 6.33878 9.55258 6.55602 8.35957C6.59525 8.14416 6.6422 7.93228 6.69611 7.72417ZM14.3333 7.72417C14.3681 7.8745 14.3996 8.02661 14.4276 8.18045C14.6596 9.45467 14.6483 10.8322 14.281 12.2757H17.7224C17.9338 11.5539 18.0471 10.7902 18.0471 10C18.0471 9.20978 17.9337 8.44604 17.7223 7.72417L14.3333 7.72417ZM17.3558 6.72417C16.2181 4.161 13.7862 2.29974 10.8895 1.96973C12.0684 3.03082 13.3456 4.6775 14.0467 6.72417L17.3558 6.72417ZM7.09915 13.2757L12.9007 13.2757C12.3473 14.639 11.4221 16.0723 9.99992 17.5439C8.57774 16.0723 7.6525 14.639 7.09915 13.2757ZM13.9719 13.2757C13.4129 14.8109 12.4385 16.4086 10.921 18.0266C13.8039 17.6867 16.2223 15.8296 17.3558 13.2757H13.9719ZM2.57323 13.2757C3.71713 15.853 6.16948 17.7206 9.08719 18.0356C7.56487 16.4145 6.58795 14.8137 6.02788 13.2757H2.57323Z",
    fill: "#394577"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.0245,
    cy: 14.3444,
    r: 4.84442,
    fill: "#394577",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5244,
    y: 11.2839,
    width: 1,
    height: 3.56049,
    rx: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2217,
    y: 13.8444,
    width: 1,
    height: 2.697,
    rx: 0.5,
    transform: "rotate(90 17.2217 13.8444)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.524,
    y: 13.8444,
    width: 1,
    height: 0.99973,
    rx: 0.499865,
    transform: "rotate(90 15.524 13.8444)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezoneIcon);
export default __webpack_public_path__ + "static/media/timezone_icon.ccb7c72e2ce51a64cdb997a20512e822.svg";
export { ForwardRef as ReactComponent };